module.exports = __webpack_public_path__ + "img/03_no.d77a2934.svg";